import type { VoiceSlot } from '@/lib/types'

/** The four required voice slots, in backbone order (ease-in → chest → head → mix). */
export const VOICE_SLOTS: { slug: VoiceSlot; label: string }[] = [
  { slug: 'ease-in', label: 'Ease-in' },
  { slug: 'chest', label: 'Chest' },
  { slug: 'head', label: 'Head' },
  { slug: 'mix', label: 'Mix' },
]

export const VOICE_LABELS: Record<VoiceSlot, string> = {
  'ease-in': 'Ease-in',
  chest: 'Chest',
  head: 'Head',
  mix: 'Mix',
}

/** Voice types offered on the build screen (SATB + mezzo & baritone). */
export const VOICE_TYPES = ['Soprano', 'Mezzo', 'Alto', 'Tenor', 'Baritone', 'Bass'] as const
export type VoiceType = (typeof VOICE_TYPES)[number]

/**
 * The cool-down tag is auto-appended after belting, so it isn't a selectable
 * focus. (The old chest/head/etc. tags were removed entirely once the voice
 * slot took over that dimension.)
 */
export const AUTO_TAG_SLUGS = ['cool-down']
export const NON_FOCUS_TAG_SLUGS = [...AUTO_TAG_SLUGS]
